import { detect } from 'detect-browser';

const browser = detect();

export const getBrowserName = () => browser.name;

export const isNativeScreenSharingSupported = !!navigator?.mediaDevices?.getDisplayMedia;
